/**
 * Centralized environment variable configuration
 * All environment variables should be accessed through this config object
 */

export const config = {
  sentry: {
    dsn: import.meta.env.VITE_SENTRY_DSN,
    environment: import.meta.env.MODE,
    release: import.meta.env.VITE_APP_VERSION || 'development',
    enabled: !!import.meta.env.VITE_SENTRY_DSN,
  },
  app: {
    isDev: import.meta.env.DEV,
    isProd: import.meta.env.PROD,
    mode: import.meta.env.MODE,
  },
} as const;

/**
 * Validates required environment variables
 * Warns in console if required variables are missing in production
 */
export function validateEnv(): void {
  const requiredVars = ['VITE_SENTRY_DSN'];
  const missing: string[] = [];

  for (const varName of requiredVars) {
    if (!import.meta.env[varName]) {
      missing.push(varName);
    }
  }

  if (missing.length > 0) {
    const message = `Missing required environment variables: ${missing.join(', ')}`;
    if (import.meta.env.PROD) {
      console.error(message);
    } else {
      console.warn(message);
    }
  }
}
